const changUrl: (url: string) => string = (url) => {
	const FIXED = `/s2`;
	const SUFFIX = `.html`;
	return FIXED + url + SUFFIX;
};

export const KEY_PATH_LOGIN = changUrl('/login'); // 登录

export const KEY_PATH_PROJECT = changUrl('/project'); // 项目

export const KEY_PATH_STANDARD_LIBRARY = changUrl('/standard-library'); // 成员标准库
export const KEY_PATH_STANDARD_LIBRARY_DETAIL = changUrl('/standard-library-detail'); // 成员标准库

export const KEY_PATH_LABEL = {
	KEY_PATH_MAJOR: changUrl('/label-standard-library-major'), // 专业标签
	KEY_PATH_TEAM: changUrl('/label-standard-library-team'), // 团队标签
	KEY_PATH_TAG: changUrl('/label-tag'), // 团队标签
};
export const KEY_PATH_ONLINE = changUrl('/data-online'); // 数据监控
export const KEY_PATH_PRINTER = changUrl('/access-printer'); // 接入印刷商
export const KEY_PATH_PRINTER_DETAIL = changUrl('/access-printer-detail'); // 接入印刷商
export const KEY_PATH_MESSAGE = {
	KEY_PATH_MESSAGE_PHONE: changUrl('/message-record-phone'),
	KEY_PATH_MESSAGE_WX: changUrl('/message-record-wx'),
	KEY_PATH_MESSAGE_WHATSAPP: changUrl('/message-record-whatsapp'),
	KEY_PATH_MESSAGE_LINE: changUrl('/message-record-line'),
	KEY_PATH_MESSAGE: changUrl('/message'),
}; // 消息记录

// 人员
export const KEY_PATH_STAFF = {
	KEY_PATH_STAFF: changUrl('/staff'), // 员工
	KEY_PATH_ENABLED_STAFF: changUrl('/enabled-staff'), // 员工
	KEY_PATH_DISABLED_STAFF: changUrl('/disabled-staff'), // 已禁用人员
};
export const KEY_PATH_PROFILE = changUrl('/profile'); // 成员

export const KEY_PATH_UI = changUrl('/ui'); // 成员

export const KEY_PATH_USERINFOPAGE = changUrl('/userinfo-page');
export const KEY_PATH_MESSAGEPAGE = changUrl('/message-page');
export const KEY_PATH_MEMBERPAGE = changUrl('/member'); // 成员
export const KEY_PATH_USER = changUrl('/user'); // 成员
export const KEY_PATH_ASYNC = {
	KEY_PATH_ASYNC_CENTER: changUrl('/async-center'),
	KEY_PATH_ASYNC_CLIENT: changUrl('/async-client'),
};
export const KEY_PATH_APPVERSION = changUrl('/app-version'); //
